import { TimeContent } from '../components/pages/collaboratorsManagement/components/InvitationTile';

function padStartNumber(n: number) {
  return String(n).padStart(2, '0');
}

function addZeroForDateField(dateField: string): string {
  if (!dateField || dateField.length > 1) {
    return dateField;
  }
  return `0${dateField}`;
}

export function formatTimestamp(timestamp: string): string {
  const date = new Date(timestamp);
  return `${padStartNumber(date.getDate())}/${padStartNumber(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function dateFormatFromDate(date: Date): string {
  if (!date) {
    return '';
  }

  const days = addZeroForDateField(date.getDate().toString());
  const months = addZeroForDateField((date.getMonth() + 1).toString());

  return `${days}/${months}/${date.getFullYear()}`;
}

export function hourFormatFromDate(date: Date): string {
  if (!date) {
    return '';
  }

  const hours = addZeroForDateField(date.getHours().toString());
  const minutes = addZeroForDateField(date.getMinutes().toString());

  return `${hours}h${minutes}`;
}

export function getHourBetweenDates(time: number): number {
  const today = Date.now();

  const diffTime = Math.abs(time - today);
  return Math.floor(diffTime / (1000 * 60 * 60));
}

export function timeBetweenDates(expiryTime: number): TimeContent {
  const today = Date.now();

  const diffTime = Math.abs(expiryTime - today);
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffTime / (1000 * 60)) - (60 * diffHours);

  const parsedMinutes = addZeroForDateField(diffMinutes.toString());

  return {
    hours: diffHours.toString(),
    minutes: parsedMinutes,
  };
}
